(() => {
  if (window.rdbDayNightMotion || !('IntersectionObserver' in window)) return;
  window.rdbDayNightMotion = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const icons = new Map();
  let suspended = false;
  const update = (icon, state) => {
    const playing = state.visible && icon.isConnected && !document.hidden && !suspended && !preference.matches;
    icon.classList.toggle('is-day-night-playing', playing);
    icon.closest('.trust-strip__accent--day-night')?.classList.toggle('is-day-night-playing', playing);
  };
  const updateAll = () => icons.forEach((state, icon) => update(icon, state));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = icons.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.9;
      update(entry.target, state);
    });
  }, { threshold: [0, 0.9, 1] });
  const initialize = () => {
    document.querySelectorAll('body.rdb-design-2 .rdb-trust-only .trust-strip__day-night').forEach(icon => {
      if (icons.has(icon)) return;
      const state = { visible: false };
      icons.set(icon, state);
      observer.observe(icon);
    });
  };
  document.addEventListener('visibilitychange', updateAll);
  preference.addEventListener('change', updateAll);
  window.addEventListener('pagehide', () => { suspended = true; updateAll(); });
  window.addEventListener('pageshow', () => { suspended = false; updateAll(); });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    icons.forEach((state, icon) => {
      if (!event.target.contains(icon)) return;
      observer.unobserve(icon);
      icon.classList.remove('is-day-night-playing');
      icon.closest('.trust-strip__accent--day-night')?.classList.remove('is-day-night-playing');
      icons.delete(icon);
    });
  });
  initialize();
})();
